import { ToastSeverity } from '../types/toast-severity';

export class Toast {
  public constructor(
    public readonly title: string,
    public readonly message: string,
    public readonly severity: ToastSeverity,
    public readonly immortal: boolean,
    public readonly life: number,
  ) {}
}
